import { useTranslation } from 'react-i18next'

import { Notice, Button } from '@buffer-mono/popcorn'

import {
  connectChannel,
  toConnectableService,
} from '~publish/helpers/channelConnections'
import type { Service } from '~publish/legacy/constants/services/ServiceDefinitions'

import type { JSX } from 'react'

export interface ProfilesDisconnectedBannerProps {
  canReconnectChannels?: boolean
  displayExtraMessage?: boolean
  ownerEmail?: string
  service?: Service | string
}
const ProfilesDisconnectedBanner = ({
  displayExtraMessage = false,
  canReconnectChannels = false,
  ownerEmail = 'the owner',
  service,
}: ProfilesDisconnectedBannerProps): JSX.Element => {
  const { t } = useTranslation()
  const connectableService = service ? toConnectableService(service) : null

  const onReconnectClick = (): void => {
    if (connectableService) {
      connectChannel({
        service: connectableService,
        isRefreshingConnection: true,
        cta: `publish-queue-channelRefreshBanner-${service}-1`,
      })
    }
  }
  return (
    <Notice variant="error" style={{ marginBottom: 'var(--space-md)' }}>
      <Notice.Heading>
        {t('profiles-disconnected-banner.headline')}
      </Notice.Heading>
      {displayExtraMessage && (
        <Notice.Text>
          <strong>
            {t('profiles-disconnected-banner.extraMessage.instagram')}
          </strong>
        </Notice.Text>
      )}
      <Notice.Text>
        {canReconnectChannels
          ? t('profiles-disconnected-banner.body')
          : t('profiles-disconnected-banner.permissionBody', {
              email: ownerEmail,
            })}
      </Notice.Text>
      {canReconnectChannels && connectableService && (
        <Notice.Actions>
          <Button size="small" variant="critical" onClick={onReconnectClick}>
            {t('profiles-disconnected-banner.cta')}
          </Button>
        </Notice.Actions>
      )}
    </Notice>
  )
}

export default ProfilesDisconnectedBanner
